import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as settingsSelectors from '../../Settings/settings.selectors'

import * as phaseActions from '../../Phases/phases.actions'
import * as settingsActions from '../../Settings/settings.actions'
import * as savePointActions from '../../SavePoint/savePoint.actions'

import MiningChangePhasePopup from './MiningChangePhasePopup'

const mapDispatchToProps = (dispatch) => ({
  nextPhase: bindActionCreators(phaseActions.nextPhase, dispatch),
  removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  setMineDisclaimer: bindActionCreators(settingsActions.setMineDisclaimer, dispatch),
  syncWithSettings: bindActionCreators(savePointActions.syncWithSettings, dispatch),
})

const mapStateToProps = (state) => ({
  settings: settingsSelectors.getSettings(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MiningChangePhasePopup))
